import LocalStorageService from '@application/common/local-storage-service';
import { jwtDecode } from 'jwt-decode';
export const getCurrentUserFromJwt = (token) => {
    const authToken = token || LocalStorageService.getAccessToken();
    if (authToken != null) {
        const decodedJWT = jwtDecode(authToken);
        const decodedRole = decodedJWT.Role;
        const rolesArray = Array.isArray(decodedRole) ? decodedRole : decodedRole ? [decodedRole] : [];
        const isCollaboratorRole = rolesArray.includes('Collaborator') || rolesArray.includes('TransportManager');
        const currentUser = {
            accessToken: authToken,
            id: decodedJWT.UserId,
            name: decodedJWT.Name,
            role: rolesArray,
            email: decodedJWT.Email,
            permissions: decodedJWT.Permission,
            ProfilePicturePath: decodedJWT.ProfilePicturePath,
            primaryCompanyId: decodedJWT.PrimaryCompanyId,
            companyLogoUrl: decodedJWT.CompanyLogoUrl,
            primaryCompanyLogoUrl: decodedJWT.PrimaryCompanyLogoUrl,
            primaryLanguageId: decodedJWT.PrimaryLanguageId,
            ...(isCollaboratorRole
                ? {
                    IsCollaborator: decodedJWT.IsCollaborator,
                    CollaboratorAccessLevel: decodedJWT.CollaboratorAccessLevel,
                    CollaboratorId: decodedJWT.CollaboratorId
                }
                : {})
        };
        return currentUser;
    }
};
